import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Observer, Subscription } from 'rxjs';
import { minutiOptions } from '../../../models/tipologiche/mock-minuti';
import { oreOptions } from '../../../models/tipologiche/mock-ore';

declare var $: any;

export const ORA_COMBO_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => OraComboComponent),
  multi: true
};

@Component({
    selector: '[oraComboInput]',
  templateUrl: 'oraCombo.component.html',
  providers: [ORA_COMBO_VALUE_ACCESSOR, NgbTooltipConfig]
})
export class OraComboComponent implements ControlValueAccessor, OnInit {
  @Input() control: AbstractControl;
  @Input() submitPending: boolean;
  @Input() objectReferenceOra: any;
  @Input() objectReferenceMin: any;
  @Output() onReturn = new EventEmitter();
  internalObject: any;
  ore = oreOptions;
  minuti = minutiOptions;
  ora: any;
  min: any;
  _value: string;
  public enableObservable: Observable<boolean>;
  subscription: Subscription = null;
  enableObserver: Observer<boolean>;  private onTouchedCallback: () => void = () => { };
  onChangeCallback: (_: any) => void = () => { };

  constructor(private httpService: HttpClient) {

  }

  private createServiceSubscription() {
    this.enableObservable = new Observable<boolean>(observer => {
      this.enableObserver = observer;
    if ( this.enableObserver) {
        this.submitPending = true;
      } else {
        this.submitPending = false;
      }
    });
  }

  ngOnInit(): void {
    if (!this.submitPending) {
      this.createServiceSubscription();
    }
  }

  ngOnChanges(): void {
    this.changeEvent();
  }


  private changeEvent() {
    this.ora = this.objectReferenceOra ? JSON.parse(JSON.stringify(this.objectReferenceOra)) : '00';
    this.min = this.objectReferenceMin ? JSON.parse(JSON.stringify(this.objectReferenceMin)) : '00';
  }

  onChange(): any {
      this.onReturn.emit(JSON.parse(JSON.stringify(this.ora + ':' + this.min)));
  }

  onBlur(t): any {
    if (this.control && !this.control.valid) {
      t.ngbTooltip = 'Il campo � obbligatorio!';
      t.open();
    } else {
      if (this.control && this.control.valid) {
        t.close();
      }
    }
  }

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
    this.changeEvent();
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }
}
